import { Box, Typography } from "@mui/material";
import { AttributeDetails } from "../mui-components/AttributeValueBox";
import Utils from "../util/Utils";
import { useSnapshot } from "valtio";
import { bookingsStore, viewBookingStore } from "../state/CommonState";
import { dsrstatic_cn } from "../my-actions/dsr_static";
import { Title } from "@mui/icons-material";
import { ServerLists } from "../StaticData";





export function CustomsDetail({data}) {
    const booking = viewBookingStore.current;
    let exportClearance = booking?.exportClearance
    let importClearance = booking?.importClearance 
    const multipleExportClearancevalue =( ()=>{
        let k = booking
        let exportKeys = Object.keys(k).filter(key => key.startsWith("exportClearance"));
        let exportValues = [];
        if (exportKeys.length > 0) {
        exportValues = exportKeys
            .sort((a, b) => {
            let numA = a.match(/\d+$/);
            let numB = b.match(/\d+$/);
            numA = numA ? parseInt(numA[0]) : 1;
            numB = numB ? parseInt(numB[0]) : 1;
            return numA - numB;
            })
            .map(key => k[key]);
        }
        return exportValues
    })()
    if (!data?.mismatch && data?.type == 'boe') {
        let boe = [{ label: 'Bill of Entry Checklist', value: `${data?.customerCompletedOn.replace(/\//g, '-').split('-').reverse().join('-')}` },
            { label: 'Bill of Entry Number', value: data.no },
            { label: 'Bill of Entry Date', value: data?.date?`${data?.date?.slice(4, 8)}-${data?.date?.slice(2, 4)}-${data?.date?.slice(0, 2)}`:"" },
            { label: 'Out of Charge Date', value:data?.oocDt?`${data?.oocDt?.slice(4, 8)}-${data?.oocDt?.slice(2, 4)}-${data?.oocDt?.slice(0, 2)}`:"" }
            ]
        importClearance = boe
        exportClearance = [{label: 'Customs Entry', value: ''},
            {label: 'Customs Reference Number', value: ''},
            {label: 'Submission to Customs Date', value: ''},
            {label: 'Cleared for export', value: ''}]
    }
    if (!data?.mismatch && data?.type == 'sbc') {
        let sbc = [{ label: 'Shipping Bill Checklist', value: `${data?.customerCompletedOn.replace(/\//g, '-').split('-').reverse().join('-')}` },
            { label: 'Shipping Bill Number', value: data.no,type:'string'},
            { label: 'Shipping Bill Date', value: data?.date?`${data?.date?.slice(4, 8)}-${data?.date?.slice(2, 4)}-${data?.date?.slice(0, 2)}`:"" },
            { label: 'Let-Export-Order Date', value:data?.leoDt?`${data?.leoDt?.slice(4, 8)}-${data?.leoDt?.slice(2, 4)}-${data?.leoDt?.slice(0, 2)}`:"" }
            ]
            
        exportClearance = sbc
        importClearance = [{label: 'Customs Entry gyyyvrf', value: ''},
            {label: 'Customs Reference Number', value: ''},
            {label: 'Submission to Customs Date', value: ''},
            {label: 'Cleared for import', value: ''}]
    }
   console.log(" the multip export is ",multipleExportClearancevalue)

    if(exportClearance && exportClearance.length>0){
        exportClearance = exportClearance.filter((exportdetail)=>exportdetail.label!=="CartingId")
    }

    if(importClearance && importClearance.length>0){
        importClearance = importClearance.filter((importdetail)=>importdetail.label!=="CartingId")
    }

    const valueExistsForExportClearance = Utils.checkForAtlestOneValue(exportClearance) || Utils.checkForAtlestOneValue(multipleExportClearancevalue[0])
    const valueExistsForImportClearance = Utils.checkForAtlestOneValue(importClearance)



    return <Box sx={{ display: "flex", flexDirection: "column", gap: 1, paddingX: "10px" }}>
       { valueExistsForExportClearance && <Typography sx={{ fontSize: "16px", fontWeight: "bold", fontFamily: "Figtree", color: "black" }}>Export Clearance ({Utils.extractCountry(bookingsStore.current?.contract?.portOfReceipt)})</Typography>}
        <Box sx={{ display: "flex", flexDirection: "column", gap:1 }}>
            <AttributeDetails details={exportClearance?.map((exportdetail) => (
                {
                    title: exportdetail.label,
                    notToShowDefault: true,
                    value: exportdetail.type ==="string" ? exportdetail.value :Utils.isValidDate1(Utils.dateConversion(exportdetail.value)) ?
                        Utils.formatDateBooking(Utils.dateConversion(exportdetail.value), false)
                        : exportdetail.value
                }
            ))} />
            {multipleExportClearancevalue.slice(1).map((exportClearance)=> <AttributeDetails details={exportClearance?.map((exportdetail) => (
                {
                    title: exportdetail.label,
                    notToShowDefault: true,
                    value:exportdetail.type ==="string" ? exportdetail.value : Utils.isValidDate1(Utils.dateConversion(exportdetail.value)) ?
                        Utils.formatDateBooking(Utils.dateConversion(exportdetail.value), false)
                        : exportdetail.value
                }
            ))} />)}
        </Box>
        { valueExistsForImportClearance && <Typography sx={{ fontSize: "16px", fontWeight: "bold", fontFamily: "Figtree", color: "black" }}>Import Clearance({Utils.extractCountry(bookingsStore.current?.contract?.finalPlaceOfDelivery)})</Typography>}
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <AttributeDetails details={importClearance?.map((exportdetail) => (
                {
                    title: exportdetail.label,
                    notToShowDefault: true,
                    value:exportdetail.type ==="string" ? exportdetail.value :
                        Utils.isValidDate1(Utils.dateConversion(exportdetail.value)) ?
                            Utils.formatDateBooking(Utils.dateConversion(exportdetail.value), false)
                            : exportdetail.value

                }
            ))} />
        </Box>
        { !valueExistsForExportClearance && !valueExistsForImportClearance && <Typography style={{textAlign:"center",fontSize: "16px", fontWeight: "bold", fontFamily: "Figtree", color: "black"}}>No Data Found</Typography> }
    </Box>
}
